import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, Space, Row } from "@masterteam/mt-design-react";

import Modal from "../Modal";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete.svg";

import "./style.scss";

const DeleteModal = ({
  ButtonStatus,
  title,
  closeModal,
  handleDelete,
  isOpen,
  customMessage
}) => {
  return (
    <Modal isOpen={isOpen}>
      <Space direction="vertical" size="large" className="delete-box-container">
        <Space
          direction="vertical"
          size="large"
          justify="center"
          align="center"
        >
          <Space direction="vertical" align="center">
            <DeleteIcon
              className="tab-icon"
              style={{
                fill: "var(--dark-gray)",
                width: 50,
                height: 50,
                verticalAlign: "bottom",
              }}
            />
            <div className="title">
              <FormattedMessage id="common.delete" /> {title}
            </div>
          </Space>
          <div className="modal-delete-body text-normal">
            {customMessage ? customMessage : <><FormattedMessage id="common.delete-message" /> {title} !</>}
          </div>
        </Space>
        <Row justify="center" size="medium">
          <Button variant="dark" type="button" onClick={closeModal}>
            <FormattedMessage id="common.cancel" />
          </Button>
          <Button
            variant="error"
            type="button"
            onClick={handleDelete}
            loading={ButtonStatus}
          >
            <FormattedMessage id="common.delete" /> !
          </Button>
        </Row>
      </Space>
    </Modal>
  );
};

export default DeleteModal;
